import { FormEvent, useContext, useState } from "react";
import { AuthContext } from "../components/AuthContextComponent";
import { BatchNumberLookUp, GetApprovers } from "../api/FetchAPI";
import { showAlert } from "../promptMessages/PromptMessages";
import { ALERTMSG } from "../lib/enums/index";
import {
  ApiRequest,
  GetApproversInfo,
  TrackInfo,
} from "../lib/interfaces/index";
import useUserLogin from "./UserLoginhook";
import { FetchErr } from "../lib/helpers/UnhandledError";
import { handleHttpError } from "../lib/helpers/HanldeHttpError";

const useTrack = () => {
  const userInfo = useContext(AuthContext);
  // const { customColor } = useUserLogin();
  const { username } = userInfo; // Only use userInfo once
  const [batchNumber, setBatchNumber] = useState("");
  const { customColor } = useUserLogin();
  const [trackinfo, setTrackInfo] = useState<TrackInfo>();
  const [loading, setLoading] = useState(false);
  const [approverInfo, setApproverInfo] = useState<GetApproversInfo | null>(
    null
  );
  //variables for theme
  const themeBackground = userInfo.userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo.userInfo?.theme === "DARK" ? "#fafbfc" : "";

  //hanlde for approving batch number
  const handleGetApprovers = async (
    batchNumber: string,
    userId: string,
    partnersId: number
  ) => {
    let requestParams: ApiRequest = {
      batchNumber: batchNumber,
      userId: userId,
      partnersId: partnersId,
    };
    try {
      const response: any = await GetApprovers(requestParams);
      if (response.respCode === 2000) {
        setApproverInfo(response);
      }
    } catch (error) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    }
  };
  //handle to track batch number
  const batchNumberLookUp = async (e: FormEvent) => {
    e.preventDefault();

    setTrackInfo(undefined);

    // Start loading
    setLoading(true);

    const partnersId = userInfo.userInfo?.partnersId || 0;

    // Use a timeout to simulate a delay if needed, but keep the API call synchronous

    try {
      const response: any = await BatchNumberLookUp(
        username,
        batchNumber,
        partnersId
      );

      if (response.respCode === 2000) {
        setTrackInfo(response);

        await handleGetApprovers(
          batchNumber,
          username,
          response.batchNumberInfo[0].partnersId
        );
      } else {
        setLoading(false);
        showAlert(
          ALERTMSG.SOMEWENTWRONG,
          response.respMsg,
          "error",
          customColor,
          themeBackground,
          themeTextColor
        );
      }
    } catch (error: any) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    } finally {
      setLoading(false);
    }
  };

  //handle for onChange of the input
  const handleInputTrack = (e: React.ChangeEvent<HTMLInputElement>) => {
    //trimmed value to clear white space
    const trimmedValue = e.target.value.trim();
    //set the value
    setBatchNumber(trimmedValue);
  };

  return {
    approverInfo,
    loading,
    batchNumber,
    trackinfo,
    handleInputTrack,
    batchNumberLookUp,
  };
};

export default useTrack;
